/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Kb4Inputs */

const en_mk_cmp_multica_kb4 = /** @type {(inputs: Mk_Cmp_Multica_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channels, threads and direct messages live inside the product.`)
};

const id_mk_cmp_multica_kb4 = /** @type {(inputs: Mk_Cmp_Multica_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel, thread, dan pesan langsung ada di dalam produk.`)
};

/**
* | output |
* | --- |
* | "Channels, threads and direct messages live inside the product." |
*
* @param {Mk_Cmp_Multica_Kb4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_kb4 = /** @type {((inputs?: Mk_Cmp_Multica_Kb4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Kb4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_kb4(inputs)
	return en_mk_cmp_multica_kb4(inputs)
});